module.exports = __webpack_public_path__ + "static/img/资讯海报@2x.acd82eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/资讯海报@2x.png
// module id = GIcs
// module chunks = 192